import React, { Component } from 'react';
import {createMuiTheme} from'@material-ui/core/styles';
import {purple, cyan, orange, red, yellow, green, pink, lime, amber, teal, deepOrange} from '@material-ui/core/colors';



export function dynamicallyBuildTheme(workspace){
  console.log(workspace, 'WORKSPACE');

  let theme_ready={
    big_shadow:'1px 1px 5px 1px #000000',
    palette: {
      background:{
        //main:'rgb(231, 252, 251)',
        main:(workspace==undefined || workspace.background_colour==undefined)?'#f5f5fd':workspace.background_colour,
      },
      primary:{
        //main:'rgb(0, 116, 225)',
        main:(workspace==undefined || workspace.primary_colour==undefined)?'#00598c':workspace.primary_colour
      },
      white:{
        main:'white'
      },
      error:{
        main:red[500],
      },
      success:{
        main:green[500],
      },
      disabled:'rgba(0, 0, 0, 0.26)',
      black:{
        main:'#000000',
      },
      secondary:{
        //main:'#f50057'
        main:(workspace==undefined || workspace.secondary_colour==undefined)?'#ff5e3d':workspace.secondary_colour
        //main:'#00aeef'
      },
      tertiary:{
        main:(workspace==undefined || workspace.tertiary_colour==undefined)?'#00aeef':workspace.tertiary_colour
      },
      professional_green:{
        full:'rgba(143, 188, 143, 0.8)',
        transparent:'rgba(143, 188, 143, 0.2)'
      },
      professional_yellow:{
        full:'rgba(255, 215, 0, 0.8)',
        transparent:'rgba(255, 215, 0, 0.2)'
      },
      professional_red:{
        full:'rgba(255, 92, 92, 0.8)',
        transparent:'rgba(255, 92, 92, 0.2)'
      },
      professional_blue:{
        full:'rgba(153, 207, 224, 0.8)',
        transparent:'rgba(153, 207, 224, 0.2)'
      }

      },
      spacing:10
  }
  if (localStorage.getItem('theme_ready_v4') && workspace==undefined) {
    // Retrieve the saved theme
    theme_ready = JSON.parse(localStorage.getItem('theme_ready_v4'));
  }else{
    localStorage.setItem('theme_ready_v4', JSON.stringify(theme_ready));
  }
  return createMuiTheme(theme_ready);
}
